
const getDefaultState = () => {
  return {
    temporary_selected_wastes_or_services: {
      work_order: {},
      wastes_or_services_by_work_order: [],
      reservation_date: {
        date: "",
        zz_day_of_time_zone_id: "",
      }
    },
  };
};

const state = getDefaultState();

const mutations = {
  SET_SELECTED_WASTE_OR_SERVICE (state, payload) {
    state.temporary_selected_wastes_or_services = payload;
  },
  RESET_SELECTED_WASTE_OR_SERVICE (state) {
    state.temporary_selected_wastes_or_services = getDefaultState().temporary_selected_wastes_or_services;
  },
};
const actions = {
  registerScheduleWasteOrService ({ commit }, payload) {
    commit('SET_SELECTED_WASTE_OR_SERVICE', payload);
  },
};
const getters = {
  temporary_selected_wastes_or_services (state) {
    return state.temporary_selected_wastes_or_services;
  },
};
export default {
  state,
  mutations,
  actions,
  getters
};
